import 'bootstrap/dist/css/bootstrap.css';
import React,{Component} from "react";
import './styles.css';
import nophoto from '../notfound-modified.png';
class Discovered extends Component{

  state = {animate: false,
           displayedArtist: null,
           sortBy: "songs"}


static CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
static CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;
  componentDidMount() {
    this.animateComponent();
    window.addEventListener('scroll', this.handleScroll);
    //this.component.classList.remove('hidden');
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.discovered[0] !== this.props.discovered[0]) {
      // Remove the animation class when changing the artist
      this.removeAnimation();

      // Set a timeout to add the animation class after a short delay
      setTimeout(() => {
        this.animateComponent();
      }, 100); // You can adjust the delay time as needed
    }
  }

  animateComponent() {
    // Set the state to enable animation
    this.setState({ animate: true });
  }

  removeAnimation() {
    // Set the state to disable animation
    this.setState({ animate: false });
  }

  handleScroll = () => {
    const { onFooterPosition } = this.props;
    const tableContainer = this.component; // Update the reference to the component itself

    if (tableContainer) {
      // Ensure tableContainer is defined
      const scrollPosition = tableContainer.scrollTop;
      const contentHeight = tableContainer.scrollHeight;
      const containerHeight = tableContainer.clientHeight;

      // Determine whether the footer should be fixed or not
      const shouldFooterBeFixed = scrollPosition + containerHeight >= contentHeight;

      onFooterPosition(shouldFooterBeFixed); // Signal the parent to update the footer position
    }
  };

  formatMilliseconds = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
  
    // Use conditional (ternary) operator to remove leading zero if minutes < 10
    const formattedMinutes = minutes < 10 ? String(minutes) : String(minutes).padStart(2, '0');
    const formattedSeconds = String(seconds).padStart(2, '0');
  
    return `${formattedMinutes}:${formattedSeconds}`;
  };
 
  toggleDropdown = (artistName) => {
    // Toggle the displayed artist when its name is clicked
  
    this.setState((prevState) => ({
      displayedArtist: prevState.displayedArtist === artistName ? null : artistName,
    }));
  };

  toggleSortBy = () => {
    this.setState((prevState) => ({
      sortBy: prevState.sortBy === 'songs' ? 'popularity' : 'songs',
    }));
  };

    render(){
      const { sortBy } = this.state;
      const { discovered } = this.props;
      //console.log("disco in table", discovered)

      const sortedKeys =
      sortBy === 'songs'
        ? Object.keys(discovered).sort((a, b) => discovered[b].length - discovered[a].length)
        : Object.keys(discovered).sort((a, b) => discovered[b].popularity - discovered[a].popularity);
return(
  <div>
    <div className='btn-group fadein'>Sort by: </div>
   <div className="btn-group fadein" role="group">
  <button
    style={{ background: sortBy === 'songs' ? '#D9E724' : '#535353', borderColor: '#8b008b', color: 'black' }}
    type="button"
    className={`btn btn-secondary ${sortBy === 'songs' ? 'active' : ''}`}
    onClick={() => this.toggleSortBy('songs')}
  >
    Number of songs
  </button>
  <button
    style={{ background: sortBy === 'popularity' ? '#D9E724' : '#535353', borderColor: '#8b008b', color: 'black' }}
    type="button"
    className={`btn btn-secondary ${sortBy === 'popularity' ? 'active' : ''}`}
    onClick={() => this.toggleSortBy('popularity')}
  >
    Discovered artist popularity
  </button>
</div>


      <div className="results-grid fadein" ref={(component) => (this.component = component)}>
        {sortedKeys.map((artistName, index) => (
            <div key={index} className="result-item" onClick={() => this.toggleDropdown(artistName)}>
              {discovered[artistName].artistimg != undefined ? (
                      <img
                          src={discovered[artistName].artistimg}
                          alt={artistName}
                          style={{ width: '75x', height: '75px' }} // Imposta la larghezza desiderata in pixel
                      />
                      ) : (
                        <img
                        src={nophoto}
                        alt={"Photo unavailable"}
                        style={{ width: '75x', height: '75px' }} // Imposta la larghezza desiderata in pixel
                    />
                      )}
              <div
                className="artist-name"
              >
                {artistName}
              </div>
              <div className="song-count">
  {discovered[artistName].length === 1
    ? `${discovered[artistName].length} song`
    : `${discovered[artistName].length} songs`}
</div>
              {this.state.displayedArtist === artistName &&  (
                <div className="fastfadein" style={{ position: "absolute", backgroundColor: "#535353", borderRadius: "5px", borderStyle: "solid", borderColor: "#D9E724", overflow: 'hidden', marginTop:"-20vh", marginBottom: "-20vh"}}>
                <table className="table table-dark table-hover" style={{ cursor: 'pointer', borderColor: "#D9E724", textAlign: "center", verticalAlign: "middle", backgroundColor: "#535353" }}>
                  <thead style={{ borderColor: '#8b008b' }}>
                    <tr>
                      <th scope="col">{artistName}</th>
                      <th scope="col">Title</th>
                      <th scope="col">Length</th>
                    </tr>
                  </thead>
                  <tbody>
                    {discovered[artistName].map((song, songIndex) => (
                      <tr key={songIndex} onClick={() => { window.location.replace(song.external_urls.spotify) }}>
                        <td>
                          <img
                            src={song.img}
                            alt={song.name}
                            style={{ width: '47.5px', height: '47.5px' }} // Imposta la larghezza desiderata in pixel
                          />
                        </td>
                        <td>{song.name}</td>
                        <td>{this.formatMilliseconds(song.duration_ms)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <p>Close</p>
              </div>
              
              
              
              )}   
            </div>
          ))}
           
      </div>
      </div>
        )
    }
}

export default Discovered;